var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"homelogado"},[_c('Header'),(_vm.flPesquisa)?_c('InputPesquisa',{attrs:{"pesquisar":_vm.pesquisar}}):_vm._e(),_c('div',{class:'container '+(_vm.flPesquisa?'mt-4':'')},[_c('Modulos',{staticStyle:{"margin-top":"15vh"}}),_c('Ferramentas',{staticClass:"mt-5"})],1),_c('Footer',{staticClass:"mt-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }